import { render, staticRenderFns } from "./BoardAdmin.vue?vue&type=template&id=2a7d103a&scoped=true"
import script from "./BoardAdmin.vue?vue&type=script&lang=js"
export * from "./BoardAdmin.vue?vue&type=script&lang=js"
import style0 from "./BoardAdmin.vue?vue&type=style&index=0&id=2a7d103a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d103a",
  null
  
)

export default component.exports